"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addProduct = exports.deleteProduct = exports.deleteRate = exports.deleteContract = exports.addRates = exports.updateExcursionContract = exports.deleteContractComment = exports.getContractComments = exports.addContractComment = exports.updateProductRates = exports.updateProduct = exports.addExcursionContract = exports.getExcursionContracts = exports.updateExcursion = exports.getExcursion = exports.addExcursion = exports.deleteVariation = exports.updateVariation = exports.addVariation = exports.loadVariations = exports.getExcursionsByRegion = exports.getExcursions = void 0;
const _ = require("lodash");
const utilities_1 = require("../utilities");
const getExcursions = async (supabase) => {
    const { data: excursions, error } = await supabase
        .from("excursions")
        .select(`*, 
      variations:excursion_variations(*),
      region:region_id ( id, name, slug, country:country_id ( id, name, slug ) ),
      contracts:excursion_contracts(*, 
        supplier:supplier_id (id, name, currency), products:excursion_contract_products(*, rates:excursion_contract_product_rates(*)))`)
        .eq("published", true)
        .order("name->en", { ascending: true });
    if (!error)
        return excursions.map((excursion) => {
            // get the golf contract ending latest]
            const latestContract = _.maxBy(excursion.contracts, (c) => {
                return c.end_date;
            });
            return {
                ...excursion,
                images: JSON.parse(excursion.images),
                contracts: excursion.contracts,
                incomplete_data: (0, utilities_1.hasExcursionIncompleteData)(excursion),
                contract_expiry_date: latestContract?.end_date,
            };
        });
    return error;
};
exports.getExcursions = getExcursions;
const getExcursionsByRegion = async (supabase, region_id) => {
    const { data: excursions, error } = await supabase
        .from("excursions")
        .select(`*, 
    variations:excursion_variations(*),
    region:region_id ( id, name, slug, country:country_id ( id, name, slug ) ),
    contracts:excursion_contracts(*, 
      supplier:supplier_id (id, name, currency), products:excursion_contract_products(*, rates:excursion_contract_product_rates(*)))`)
        .eq("published", true)
        .or(`alt_region_id.eq.${region_id},region_id.eq.${region_id}`)
        .order("name->en", { ascending: true });
    if (!error)
        return excursions.map((excursion) => {
            // get the golf contract ending latest]
            const latestContract = _.maxBy(excursion.contracts, (c) => {
                return c.end_date;
            });
            return {
                ...excursion,
                images: JSON.parse(excursion.images),
                contracts: excursion.contracts,
                incomplete_data: (0, utilities_1.hasExcursionIncompleteData)(excursion),
                contract_expiry_date: latestContract?.end_date,
            };
        });
    return error;
};
exports.getExcursionsByRegion = getExcursionsByRegion;
const loadVariations = async (supabase, excursion_id) => {
    const { data: variations, error } = await supabase
        .from("excursion_variations")
        .select(`*`)
        .eq("excursion_id", excursion_id)
        .order("name", { ascending: true });
    if (!error)
        return variations;
    return error;
};
exports.loadVariations = loadVariations;
const addVariation = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    obj.modified_by = user?.id;
    obj.created_by = user?.id;
    const { data, error } = await supabase
        .from("excursion_variations")
        .insert([obj])
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.addVariation = addVariation;
const updateVariation = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    updateObj.modified_by = user?.id;
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    const { data, error } = await supabase
        .from("excursion_variations")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateVariation = updateVariation;
const deleteVariation = async (supabase, id) => {
    const { error } = await supabase
        .from("excursion_variations")
        .delete()
        .eq("id", id);
    if (!error)
        return true;
    return error;
};
exports.deleteVariation = deleteVariation;
const addExcursion = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    obj.modified_by = user?.id || "";
    obj.created_by = user?.id || "";
    const { data, error } = await supabase
        .from("excursions")
        .insert([obj])
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.addExcursion = addExcursion;
const getExcursion = async (supabase, id) => {
    const { data: attraction, error } = await supabase
        .from("excursions")
        .select(`*,
      region:region_id ( id, name, slug, country:country_id ( id, name ) ),
      variations:excursion_variations(*),
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .eq("id", id)
        .single();
    if (!error)
        return attraction;
    return error;
};
exports.getExcursion = getExcursion;
const updateExcursion = async (supabase, obj) => {
    const updateObj = _.cloneDeep(obj);
    const { data: { user }, } = await supabase.auth.getUser();
    updateObj.modified_by = user?.id || "";
    delete updateObj.created_by_user;
    delete updateObj.modified_by_user;
    delete updateObj.region;
    delete updateObj.variations;
    const { data, error } = await supabase
        .from("excursions")
        .update(updateObj)
        .eq("id", updateObj.id)
        .select(`*,
      modified_by_user:modified_by(id, first_name, last_name), 
      created_by_user:created_by(id, first_name, last_name)`)
        .single();
    if (!error)
        return data;
    return error;
};
exports.updateExcursion = updateExcursion;
const getExcursionContracts = async (supabase, id) => {
    const { data: course, error: course_error } = await supabase
        .from("excursions")
        .select("*")
        .eq("id", id)
        .single();
    const { data: platforms, error: platforms_error } = await supabase
        .from("platforms")
        .select("*");
    const { data: variations, error: variations_error } = await supabase
        .from("excursion_variations")
        .select("*")
        .eq("excursion_id", id);
    const { data: contracts, error } = await supabase
        .from("excursion_contracts")
        .select(`*, 
      excursions:excursion_id (id, name), 
      supplier:supplier_id (id, name, currency), 
      excursion_contract_notes(count),
      excursion_contract_products(
        *,
        excursion_variations:excursion_variation_id(*),
        excursion_contract_product_rates(
          *
        )
      )`)
        .eq("excursion_id", id);
    if (!error && !platforms_error && !course_error)
        return {
            course: {
                id: course.id,
                name: course.name,
            },
            platforms: platforms,
            variations: variations,
            contracts: contracts.length === 0
                ? []
                : contracts.map((contract) => ({
                    id: contract.id,
                    currency_code: contract.currency_code,
                    start_date: contract.start_date,
                    end_date: contract.end_date,
                    type: contract.type,
                    created_at: contract.created_at,
                    platforms: contract.platforms,
                    comments_count: contract.excursion_contract_notes[0].count,
                    supplier: {
                        id: contract.supplier.id,
                        name: contract.supplier.name,
                        currency: contract.supplier.currency,
                    },
                    products: contract.excursion_contract_products.map((product) => ({
                        id: product.id,
                        excursion_variation_id: product.excursion_variation_id,
                        contract_id: contract.id,
                        note: product.note,
                        created_at: product.created_at,
                        rates: product.excursion_contract_product_rates.map((rate) => ({
                            id: rate.id,
                            contract_id: contract.id,
                            contract_product_id: product.id,
                            availability_days: rate.availability_days,
                            min_pax: rate.min_pax,
                            max_pax: rate.max_pax,
                            cost_price: rate.cost_price,
                            margin: rate.margin,
                            sell_price: rate.sell_price,
                            created_at: rate.created_at,
                        })),
                    })),
                })),
        };
};
exports.getExcursionContracts = getExcursionContracts;
const addExcursionContract = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("excursion_contracts")
        .upsert(obj)
        .single();
    if (!error)
        return data;
    return error;
};
exports.addExcursionContract = addExcursionContract;
const updateProduct = async (supabase, product) => {
    const obj = _.cloneDeep(product);
    // delete rates
    delete obj.rates;
    const { data, error } = await supabase
        .from("excursion_contract_products")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateProduct = updateProduct;
const updateProductRates = async (supabase, rates) => {
    const obj = _.cloneDeep(rates);
    // in each rate delete the contract_id property
    obj.forEach((rate) => {
        delete rate.contract_id;
    });
    const { data, error } = await supabase
        .from("excursion_contract_product_rates")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateProductRates = updateProductRates;
const addContractComment = async (supabase, obj) => {
    const { data: { user }, } = await supabase.auth.getUser();
    obj.modified_by = user?.id;
    obj.created_by = user?.id;
    const { data, error } = await supabase
        .from("excursion_contract_notes")
        .insert([obj])
        .single();
    if (!error)
        return data;
    return error;
};
exports.addContractComment = addContractComment;
const getContractComments = async (supabase, id) => {
    const { data, error } = await supabase
        .from("excursion_contract_notes")
        .select(`*,
    modified_by_user:modified_by(id, first_name, last_name), 
    created_by_user:created_by(id, first_name, last_name)`)
        .eq("excursion_contract_id", id)
        .order("created_at", { ascending: false });
    if (!error)
        return data;
    return error;
};
exports.getContractComments = getContractComments;
const deleteContractComment = async (supabase, id) => {
    const { data, error } = await supabase
        .from("excursion_contract_notes")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteContractComment = deleteContractComment;
const updateExcursionContract = async (supabase, contracts) => {
    const obj = _.cloneDeep(contracts);
    obj.forEach((contract) => {
        delete contract.products;
    });
    const { data, error } = await supabase
        .from("excursion_contracts")
        .upsert(obj);
    if (!error)
        return data;
    return error;
};
exports.updateExcursionContract = updateExcursionContract;
const addRates = async (supabase, obj) => {
    const { data, error } = await supabase
        .from("excursion_contract_product_rates")
        .upsert(obj)
        .select("*");
    if (!error)
        return data;
    return error;
};
exports.addRates = addRates;
const deleteContract = async (supabase, id) => {
    await supabase
        .from("excursion_contract_notes")
        .delete()
        .eq("excursion_contract_id", id);
    const { data, error } = await supabase
        .from("excursion_contracts")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteContract = deleteContract;
const deleteRate = async (supabase, id) => {
    const { data, error } = await supabase
        .from("excursion_contract_product_rates")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteRate = deleteRate;
const deleteProduct = async (supabase, id) => {
    await supabase
        .from("excursion_contract_product_rates")
        .delete()
        .eq("contract_product_id", id);
    const { data, error } = await supabase
        .from("excursion_contract_products")
        .delete()
        .eq("id", id);
    if (!error)
        return data;
    return error;
};
exports.deleteProduct = deleteProduct;
const addProduct = async (supabase, product) => {
    const obj = _.cloneDeep(product);
    // delete rates
    delete obj.rates;
    delete obj.config;
    const { data, error } = await supabase
        .from("excursion_contract_products")
        .insert([obj])
        .select()
        .single();
    if (!error)
        return data;
    return error;
};
exports.addProduct = addProduct;
